import { Legs3D, Legs3DRonde, LegsAxel, LegsBrago, LegsButterfly, LegsClassico, LegsCono, LegsDiamond, LegsEbonu3DoubleEik, LegsEbonu3DoubleStaal, LegsEbonu3Eik, LegsEbonu3Staal, LegsEbonuEik, LegsEbonuStaal, LegsEbu, LegsElmo, LegsElmoDouble, LegsFalke, LegsFly, LegsHarper, LegsHarper3, LegsJulio3, LegsJulio4, LegsLivio, LegsLivioSchuinEik, LegsLivioSchuinStaal, LegsMPootRecht, LegsMPootSchuin, LegsMadrid, LegsNewly, LegsNovaroDoubleEik, LegsNovaroDoubleStaal, LegsNovaroEik, LegsNovaroStaal, LegsOdil3, LegsOdil4, LegsOslo, LegsOxford, LegsPapillon, LegsPapillonStrak, LegsPino, LegsRafino, LegsRobuDoubleEik, LegsRobuDoubleStaal, LegsRobuEik, LegsRobuStaal, LegsRoia, LegsTPoot, LegsTPootRonde, LegsTrapezium, LegsTwist3, LegsTwist4, LegsUPoot, LegsXPoot, TopCircle, TopDanishOval, TopHalfCircle, TopHalfOval, TopOval, TopRectangle } from '../__generated/model/index.js';
/**
 * Localizable labels used for recipe selection and product description.
 */ export const LEGS_LABEL_MAP = {
    [Legs3D.type]: '3D Poot',
    [Legs3DRonde.type]: '3D Poot Ronde',
    [LegsAxel.type]: 'Axel',
    [LegsBrago.type]: 'Brago',
    [LegsButterfly.type]: 'Butterfly',
    [LegsClassico.type]: 'Classico',
    [LegsCono.type]: 'Cono',
    [LegsDiamond.type]: 'Diamond',
    [LegsEbonuEik.type]: 'Ebonu Eik',
    [LegsEbonuStaal.type]: 'Ebonu Staal',
    [LegsEbonu3Eik.type]: 'Ebonu 3 Rond Eik',
    [LegsEbonu3Staal.type]: 'Ebonu 3 Rond Staal',
    [LegsEbonu3DoubleEik.type]: 'Ebonu 3 Eik',
    [LegsEbonu3DoubleStaal.type]: 'Ebonu 3 Staal',
    [LegsEbu.type]: 'Ebu',
    [LegsElmo.type]: 'Elmo Rond',
    [LegsElmoDouble.type]: 'Elmo',
    [LegsFalke.type]: 'Falke',
    [LegsFly.type]: 'Fly',
    [LegsHarper.type]: 'Harper',
    [LegsHarper3.type]: 'Harper Rond',
    [LegsJulio3.type]: 'Julio 3',
    [LegsJulio4.type]: 'Julio 4',
    [LegsLivio.type]: 'Livio',
    [LegsLivioSchuinEik.type]: 'Livio Schuin Eik',
    [LegsLivioSchuinStaal.type]: 'Livio Schuin Staal',
    [LegsMPootSchuin.type]: 'M-Poot Schuin',
    [LegsMPootRecht.type]: 'M-Poot Recht',
    [LegsMadrid.type]: 'Madrid',
    [LegsNewly.type]: 'Newly',
    [LegsNovaroEik.type]: 'Novaro Rond Eik',
    [LegsNovaroStaal.type]: 'Novaro Rond Staal',
    [LegsNovaroDoubleEik.type]: 'Novaro Eik',
    [LegsNovaroDoubleStaal.type]: 'Novaro Staal',
    [LegsOdil3.type]: 'Odil 3',
    [LegsOdil4.type]: 'Odil 4',
    [LegsOslo.type]: 'Oslo',
    [LegsOxford.type]: 'Oxford',
    [LegsPapillon.type]: 'Papillon',
    [LegsPapillonStrak.type]: 'Papillon Strak',
    [LegsPino.type]: 'Pino',
    [LegsRafino.type]: 'Rafino',
    [LegsRobuEik.type]: 'Robu Rond Eik',
    [LegsRobuStaal.type]: 'Robu Rond Staal',
    [LegsRobuDoubleEik.type]: 'Robu Eik',
    [LegsRobuDoubleStaal.type]: 'Robu Staal',
    [LegsRoia.type]: 'Roia',
    [LegsTPoot.type]: 'T-Poot',
    [LegsTPootRonde.type]: 'T-Poot Rond',
    [LegsTrapezium.type]: 'Trapezium',
    [LegsTwist3.type]: 'Twist Rond',
    [LegsTwist4.type]: 'Twist',
    [LegsUPoot.type]: 'U-Poot',
    [LegsXPoot.type]: 'X-Poot'
};
export const TOP_SHAPE_LABEL_MAP = {
    [TopCircle.type]: {
        id: "7xMmki",
        message: "Circle"
    },
    [TopDanishOval.type]: {
        id: "+5L3Ld",
        message: "Danish Oval"
    },
    [TopHalfCircle.type]: {
        id: "EtWvqP",
        message: "Half Circle"
    },
    [TopHalfOval.type]: {
        id: "iaL74d",
        message: "Half Oval"
    },
    [TopOval.type]: {
        id: "NAZGMM",
        message: "Oval"
    },
    [TopRectangle.type]: {
        id: "30KLDI",
        message: "Rectangle"
    }
};

//# sourceMappingURL=labels.js.map